"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import API from "@ym-framework/api-utils";
import { APIDataSource } from "@/components/grid/data-source";
const emptyImage = require("@/assets/img/safety-empty/security-list-null.png");
import DateFormat from "@/framework/timeformatter";
let MonitorLog = class extends Vue {
  constructor() {
    super(...arguments);
    this.gridController = new GridController(
      new APIDataSource("api://base.auth/api/v1/monitor-log")
    );
    this.empty_image = emptyImage;
    // 搜索表单数据
    this.searchForm = {
      account: "",
      shopId: "",
      dateRange: [],
      operationBehavior: "",
      warnEvent: "",
      webName: ""
    };
    this.pickerOptions = {
      shortcuts: [{
        text: this.$t("loginlogs.nearweeks"),
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1e3 * 24 * 7);
          picker.$emit("pick", [start, end]);
        }
      }]
    };
    this.accountList = [];
    this.shopList = [];
    this.eventList = [];
    this.operationList = [
      {
        id: "COPY",
        name: this.$t("monitor_log.operation_copy")
      },
      {
        id: "DOWNLOAD",
        name: this.$t("monitor_log.operation_download")
      },
      {
        id: "UPLOAD",
        name: this.$t("monitor_log.operation_upload")
      },
      {
        id: "PRINT",
        name: this.$t("monitor_log.operation_print")
      },
      {
        id: "DEVELOPER_MODE",
        name: this.$t("monitor_log.operation_developer_mode")
      },
      {
        id: "VISIT_WEBPAGE",
        name: this.$t("monitor_log.operation_visit_webpage")
      },
      {
        id: "KEYBOARD_INPUT",
        name: this.$t("monitor_log.operation_keyboard_input")
      },
      {
        id: "LEFT_MOUSE_CLICK",
        name: this.$t("monitor_log.operation_click")
      },
      {
        id: "RIGHT_MOUSE_CLICK",
        name: this.$t("monitor_log.operation_right_click")
      }
    ];
    this.selected = [];
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.getSubAccountList();
      yield this.getShopList();
      yield this.getEventList();
      if (this.$route.query && this.$route.query.shopId) {
        this.searchForm.shopId = this.$route.query.shopId;
        this.gridController.query.params = {
          shopId: this.searchForm.shopId
        };
      }
      if (this.$route.query && this.$route.query.userId) {
        this.searchForm.account = this.$route.query.userId;
        this.gridController.query.params = {
          accountId: this.searchForm.account
        };
      }
      yield this.gridController.search();
    });
  }
  // 获取全部子账号
  getSubAccountList() {
    return __async(this, null, function* () {
      try {
        const userResponse = yield API.get(
          `api://base.auth/api/v7/users_all_with_account`
        );
        this.accountList = userResponse.data.datas;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  handleSelectionChange(selected) {
    return __async(this, null, function* () {
      this.selected = selected;
    });
  }
  formatTime(time) {
    if (time && time !== 0) {
      return DateFormat.dateformat(DateFormat.check(time));
    } else {
      return "-";
    }
  }
  checkAccount(account) {
    return account.substring(account.length - 4, account.length);
  }
  // 获取全部事件列表
  getEventList() {
    return __async(this, null, function* () {
      try {
        const eventResponse = yield API.get(
          `api://base.auth/api/v1/monitor/alarm/internal-events-list`
        );
        this.eventList = eventResponse.data.datas;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  // 获取全部店铺列表
  getShopList() {
    return __async(this, null, function* () {
      try {
        const shopResponse = yield API.get(`api://base.auth.pro/v1/shops-lists`, {
          params: {
            type: "VD_BIND"
          }
        });
        this.shopList = shopResponse.data.datas;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  // 查询方法
  handleSearch() {
    return __async(this, null, function* () {
      try {
        this.gridController.query.params = __spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, (() => {
          if (this.searchForm.warnEvent && this.searchForm.warnEvent !== "") {
            return {
              warnEvent: this.searchForm.warnEvent
            };
          }
          return {};
        })()), (() => {
          if (this.searchForm.operationBehavior && this.searchForm.operationBehavior !== "") {
            return {
              operationBehavior: this.searchForm.operationBehavior
            };
          }
          return {};
        })()), (() => {
          if (this.searchForm.webName && this.searchForm.webName !== "") {
            return {
              webName: this.searchForm.webName
            };
          }
          return {};
        })()), (() => {
          if (this.searchForm.account && this.searchForm.account !== "") {
            return {
              accountId: this.searchForm.account
            };
          }
          return {};
        })()), (() => {
          if (this.searchForm.shopId && this.searchForm.shopId !== "") {
            return {
              shopId: this.searchForm.shopId
            };
          }
          return {};
        })()), (() => {
          if (this.searchForm.dateRange && this.searchForm.dateRange.length > 0) {
            let startTime = Math.floor(Date.parse(this.searchForm.dateRange[0]) / 1e3);
            let endTime = Math.floor(Date.parse(this.searchForm.dateRange[1]) / 1e3);
            return {
              startTime,
              endTime
            };
          }
          return {};
        })());
        yield this.gridController.search();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  // 重置方法
  handleReset() {
    return __async(this, null, function* () {
      try {
        this.searchForm = {
          account: "",
          shopId: "",
          dateRange: [],
          operationBehavior: "",
          warnEvent: "",
          webName: ""
        };
        this.gridController.query.params = __spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, (() => {
          if (this.searchForm.warnEvent && this.searchForm.warnEvent !== "") {
            return {
              warnEvent: this.searchForm.warnEvent
            };
          }
          return {};
        })()), (() => {
          if (this.searchForm.operationBehavior && this.searchForm.operationBehavior !== "") {
            return {
              operationBehavior: this.searchForm.operationBehavior
            };
          }
          return {};
        })()), (() => {
          if (this.searchForm.webName && this.searchForm.webName !== "") {
            return {
              webName: this.searchForm.webName
            };
          }
          return {};
        })()), (() => {
          if (this.searchForm.account && this.searchForm.account !== "") {
            return {
              accountId: this.searchForm.account
            };
          }
          return {};
        })()), (() => {
          if (this.searchForm.shopId && this.searchForm.shopId !== "") {
            return {
              shopId: this.searchForm.shopId
            };
          }
          return {};
        })()), (() => {
          if (this.searchForm.dateRange && this.searchForm.dateRange.length > 0) {
            let startTime = Math.floor(Date.parse(this.searchForm.dateRange[0]) / 1e3);
            let endTime = Math.floor(Date.parse(this.searchForm.dateRange[1]) / 1e3);
            return {
              startTime,
              endTime
            };
          }
          return {};
        })());
        yield this.gridController.search();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  CheckDetail(row) {
    return __async(this, null, function* () {
      try {
        this.$router.push("/monitor_log_detail?id=" + row.logId);
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
MonitorLog = __decorateClass([
  Component({
    components: {
      UiGrid
    }
  })
], MonitorLog);
export {
  MonitorLog as default
};
